export default "__VITE_ASSET__Dcdk9ufM__"